import { render, staticRenderFns } from "./CelulaDadosProcedimento.vue?vue&type=template&id=46d9803e&"
import script from "./CelulaDadosProcedimento.vue?vue&type=script&lang=js&"
export * from "./CelulaDadosProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports